import React, { Component, Fragment } from 'react';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { modelOf } from '../../../prop-types';
import ConfigStore from '../../../store/ConfigStore';
import Product from '../../../models/Product';
import WysiwygContent from '../../common/WysiwygContent';
import ButtonLink from '../../common/ButtonLink';
import globalTranslations from '../../../i18n/globalTranslations';

const READ_MORE_ACTIVATION_LENGTH = 170;

export class ProductDescription extends Component {
  getSeoShortDescription = () => {
    const { product, overflowHandler, isProductPage } = this.props;

    if (!product.seoDescription) {
      return null;
    }

    const hasMoreContent =
      product.seoDescription.length >= READ_MORE_ACTIVATION_LENGTH;
    const description = hasMoreContent
      ? product.seoDescription + '... '
      : product.seoDescription;

    return (
      <Fragment>
        {description}
        {hasMoreContent &&
          isProductPage && (
            <ButtonLink
              className="ProductPageContent__read-more-description-link"
              onClick={() => overflowHandler()}
            >
              <FormattedMessage {...globalTranslations.readMoreSentence} />
            </ButtonLink>
          )}
      </Fragment>
    );
  };

  getShortDescription = () => {
    const { product } = this.props;

    return !!product.description_short ? (
      <WysiwygContent html={product.description_short} />
    ) : null;
  };

  getDangerouslyDescription = () => {
    const { product } = this.props;
    return (
      <span
        dangerouslySetInnerHTML={{ __html: product.suitability_description }}
      />
    );
  };

  hasShortDescription = () => {
    const { product } = this.props;
    return !!product.description_short && product.description_short.length > 0;
  };

  getDescriptionContent = () => {
    const { configStore, isSuitability } = this.props;

    if (isSuitability) {
      return this.getDangerouslyDescription();
    }

    return configStore.product.useSeoDescriptionForShort &&
      !this.hasShortDescription()
      ? this.getSeoShortDescription()
      : this.getShortDescription();
  };

  render() {
    const { className } = this.props;
    const content = this.getDescriptionContent();

    if (!content) {
      return null;
    }

    return (
      <div className={classNames('ProductDescription', className)}>
        {content}
      </div>
    );
  }
}

ProductDescription.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  product: modelOf(Product).isRequired,
  overflowHandler: PropTypes.func,
  className: PropTypes.string,
  isProductPage: PropTypes.bool,
  isSuitability: PropTypes.bool
};

ProductDescription.defaultProps = {
  isProductPage: false,
  isSuitability: false
};

export default inject('configStore')(ProductDescription);



// WEBPACK FOOTER //
// ./src/components/product/ProductDescription/index.jsx